export const MER_CONTACTS_ERROR_CODES = ['MER-PAY-2048', 'MER-PAY-2049', 'MER-PAY-2050']
